import type { ButtonProps } from '@archipro-design/aria';
import { Button, useTheme } from '@archipro-design/aria';
import { DeleteBinLine, ThumbUpLine } from '@archipro-design/icons';
import React, { type JSX } from 'react';

interface UseProductTileBottomsActionsProps {
    approved: boolean;
    onClickThumb: (e: React.SyntheticEvent<HTMLElement>) => void;
    disableThumb: boolean;
    onClickBin: (e: React.SyntheticEvent<HTMLElement>) => void;
    disableBin: boolean;
}

const useProductTileBottomActions = ({
    approved,
    onClickThumb,
    disableThumb,
    onClickBin,
    disableBin,
}: UseProductTileBottomsActionsProps): JSX.Element[] => {
    const theme = useTheme();
    const buttonProps = {
        size: 18,
        color: 'white',
        variables: {
            buttonRadius: '50%',
            iconPadding: 0,
            buttonPadding: 8,
            whiteButtonBackgroundColorHover:
                theme.siteVariables.naturalColors.charcoal[250],
            whiteButtonTextColorNormal:
                theme.siteVariables.colors.charcoal['000'],
            whiteButtonTextColorHover:
                theme.siteVariables.naturalColors.white['FFF'],
        },
    } as ButtonProps;

    const bottomsActions = [
        <Button
            {...buttonProps}
            icon={<DeleteBinLine />}
            key={`product-tag-tile-bin-icon`}
            onClick={onClickBin}
            disabled={disableBin}
        />,
        <Button
            {...buttonProps}
            variables={{
                ...buttonProps.variables,
                whiteButtonBackgroundColorNormal: approved
                    ? theme.siteVariables.colors.gold['000']
                    : theme.siteVariables.naturalColors.white['FFF'],
                whiteButtonTextColorNormal: approved
                    ? theme.siteVariables.colors.white['FFF']
                    : theme.siteVariables.colors.charcoal['000'],
            }}
            icon={<ThumbUpLine />}
            key={`product-tag-tile-thumb-icon`}
            disabled={disableThumb}
            onClick={onClickThumb}
        />,
    ];

    return bottomsActions;
};

export default useProductTileBottomActions;
